import React from 'react'
import clsx from 'clsx'

import Link from 'components/Link'
import Typography from 'components/Typography'
import { values } from 'appConstants'
import { useBreakpoint } from 'utils/Hooks'
import Grid from '@mui/material/Grid'
import Button from 'components/Button'
import DiscordIcon from 'components/Icon/DiscordIcon'
import InstagramOutlineIcon from 'components/Icon/InstagramOutlineIcon'
import TwitterIcon from 'components/Icon/TwitterIcon'
import SubmitEmailNotification from 'containers/AppPage/components/SubmitEmailNotification'

import stylesGlobal from 'stylesGlobal.module.scss'
import styles from './Footer.module.scss'

type FooterGeneralProps = {
  className?: string
}

const FooterGeneral: React.FC<FooterGeneralProps> = props => {
  const { className } = props

  const { isSmallscreenAbove } = useBreakpoint()

  return (
    <div
      className={clsx(
        stylesGlobal.WidthFull,
        isSmallscreenAbove ? stylesGlobal.PaddingBottom88 : stylesGlobal.PaddingBottom64,
        stylesGlobal.Container,
        className
      )}
    >
      <div
        className={clsx(
          stylesGlobal.BorderTopPrimary,
          isSmallscreenAbove ? stylesGlobal.PaddingTop24 : stylesGlobal.PaddingTop32
        )}
      >
        <Grid container>
          <Grid xs={12} sm={6} item>
            <div
              className={clsx(
                stylesGlobal.MarginBottom40,
                !isSmallscreenAbove && stylesGlobal.TextCenter
              )}
            >
              <Typography variant="h5" fontWeight="bold" component="div">
                Creators
              </Typography>

              <Typography variant="body1">Host your next project on Art Mine</Typography>

              <Grid
                spacing={1}
                className={clsx(
                  stylesGlobal.MarginTop16,
                  stylesGlobal.MarginLeft0,
                  !isSmallscreenAbove && stylesGlobal.JustifyContentCenter,
                  styles.FooterForm
                )}
                container
              >
                <Button
                  href={values.PLAYFORM_ARTMINE_LEARN_MORE}
                  target="_blank"
                  color="secondary"
                  variant="contained"
                >
                  Submit Your Own Project
                </Button>
              </Grid>
            </div>
          </Grid>

          <Grid xs={12} sm={6} item>
            <div
              className={
                isSmallscreenAbove
                  ? stylesGlobal.MarginBottom40
                  : clsx(stylesGlobal.MarginBottom48, stylesGlobal.TextCenter)
              }
            >
              <Typography variant="h5" fontWeight="bold" component="div">
                Collectors
              </Typography>

              <Typography variant="body1">Be the first notified of future drops</Typography>

              <SubmitEmailNotification spacing={1} mode="home" className={styles.FooterForm} />
            </div>
          </Grid>
        </Grid>

        <div className={styles.FooterSocialContainer}>
          <ul
            className={clsx(
              stylesGlobal.DisplayFlex,
              stylesGlobal.ListNone,
              stylesGlobal.Padding0,
              styles.FooterSocial
            )}
          >
            <li className={styles.FooterSocialItem}>
              <Button variant="contained" href={values.DISCORD} target="_blank" icon>
                <DiscordIcon />
              </Button>
            </li>

            <li className={styles.FooterSocialItem}>
              <Button variant="contained" href={values.TWITTER} target="_blank" icon>
                <TwitterIcon />
              </Button>
            </li>

            <li className={styles.FooterSocialItem}>
              <Button variant="contained" href={values.INSTAGRAM} target="_blank" icon>
                <InstagramOutlineIcon />
              </Button>
            </li>
          </ul>

          <Link href={values.PLAYFORM_URL}>
            <Typography variant="body2" color="light" component="span">
              Created by Playform
            </Typography>
          </Link>
        </div>

        <div
          className={
            isSmallscreenAbove
              ? stylesGlobal.MarginTop24
              : clsx(stylesGlobal.MarginTop32, stylesGlobal.TextCenter)
          }
        >
          <Link href={values.PLAYFORM_URL}>
            <Typography variant="body2" component="span" fontWeight="semibold">
              Read Terms of Service
            </Typography>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default FooterGeneral
